<template>
  <div class="dacb-reply-box">
    <span class="dacb-connection-error">{{ $t("connectionError") }}</span>
    <span v-if="status === 'pending'" class="dacb-message-pending"></span>
    <textarea
      ref="message"
      v-model="message"
      :placeholder="typeSomething"
      maxLength="1000"
      @keyup="validate()"
      @keydown.enter="keydownEnter"
      @focus="inputFocus"
      @blur="inputBlur"
    ></textarea>
    <span
      v-if="status === 'ready' || status === 'pending'"
      class="dacb-send-message-btn"
      :class="{ '-active': valid && status === 'ready', '-sending': status === 'pending' }"
      :style="{
        backgroundImage: 'url(' + sendIconSrc + ')',
        backgroundColor: textColor,
        color: textColor
      }"
      @click.prevent="postMessage"
    ></span>
    <span v-if="status === 'pending'" class="dacb-sending-spinner"></span>
  </div>
</template>

<script>
import { mapState } from "vuex";

import sendIconSrc from "@/assets/send-icon.svg";
import bus from "@/helpers/bus";

export default {
  name: "ReplyBox",

  data() {
    return {
      sendIconSrc,
      valid: false,
      message: "",
      status: "ready",
      typeSomething: `${this.$t("typeSomething")}...`
    };
  },

  computed: {
    ...mapState({
      options: (state) => state.options.options,
      mobileMode: (state) => state.settings.mobileMode
    }),

    backgroundColor() {
      return this.valid ? `${this.options.primaryColour} !important` : "#CCCCCCEE !important";
    },

    textColor() {
      return this.valid ? `${this.options.textColour} !important` : "#FFFFFFEE !important";
    }
  },

  mounted() {
    if (!this.mobileMode) this.$refs.message.focus();
  },

  methods: {
    inputFocus() {
      if (this.mobileMode) {
        bus.$emit("messageList:doScroll");
        bus.$emit("inputFocus");
      }
    },

    inputBlur() {
      if (this.mobileMode) bus.$emit("inputBlur");
    },

    validate() {
      this.valid = this.message.length > 0;
    },

    keydownEnter(ev) {
      if (ev.shiftKey) return;
      ev.preventDefault();
      this.postMessage();
    },

    postMessage() {
      const content = this.message.trim();
      if (!content.length || this.status === "pending") return;

      this.status = "pending";
      if (this.$refs.message) {
        this.$refs.message.blur();
      }

      return this.$store
        .dispatch("createMessage", { content })
        .then(() => {
          this.message = "";
          this.valid = false;
        })
        .catch((err) => {
          console.error("error adding message", err);
        })
        .finally(() => {
          this.status = "ready";
          if (this.$refs.message) {
            this.$refs.message.focus();
          }
        });
    }
  }
};
</script>
